"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubPageContent = exports.ListItem = exports.List = exports.Title = exports.BackButton = exports.Header = exports.Content = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.Content = styled_components_1.default.div `
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: block;
  overflow-y: scroll;

  background-color: ${({ theme }) => theme.colors.white.s100};

  &.header--menu-enter {
    right: 100%;
  }

  &.header--menu-enter-active {
    right: 0;

    transition: right ease-in-out 150ms;
  }

  &.header--menu-exit {
    right: 0;
  }

  &.header--menu-exit-active {
    right: 100%;

    transition: right ease-in-out 150ms;
  }
`;
exports.Header = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
  padding: ${({ theme }) => theme.space.s050} 0;

  border-bottom: 1px solid ${({ theme }) => theme.colors.gray.s300};
`;
exports.BackButton = styled_components_1.default.div `
  position: absolute;
  top: 10px;
  left: 10px;

  :hover {
    cursor: pointer;

    svg path {
      fill: ${({ theme }) => theme.colors.main.base};
    }
  }
`;
exports.Title = styled_components_1.default.h1 `
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.textMain)};
`;
exports.List = styled_components_1.default.ul `
  padding: 0;
  margin: 0;
`;
exports.ListItem = styled_components_1.default.li `
  display: flex;
  padding: ${({ theme }) => theme.space.s200};

  border-bottom: 1px solid ${({ theme }) => theme.colors.gray.s300};

  list-style: none;

  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.textMain)};

  :hover {
    cursor: pointer;
  }
`;
exports.SubPageContent = styled_components_1.default.p `
  margin: ${({ theme }) => theme.space.s200};
`;
